import { Inject } from '@angular/core';
import templateSource from './app.component.html';
              import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz');
import { Component, OnInit, ChangeDetectorRef, enableProdMode } from '@angular/core';
import { Router, NavigationStart, RoutesRecognized, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { TranslateService } from '@ngx-translate/core';

const POS_ROUTE_DEBUG_VERSION = '20260507-pos-customer-debug1';

@Component({
    selector: 'app-root',
template: templateSource || '',
    styles: [``],
})
export class AppComponent implements OnInit {
    constructor(@Inject( Service)         public service: Service,@Inject( Router)         public router: Router,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( TranslateService    )         public translate: TranslateService    ) {
        window['MonacoEnvironment'] = {
            getWorkerUrl: function (moduleId: string, label: string) {
                return `/lib/vs/base/worker/workerMain.js`;
            }
        };
        window['POS_ROUTE_DEBUG_VERSION'] = POS_ROUTE_DEBUG_VERSION;
        this.installRouteDebugHooks();
    }

    public async ngOnInit() {
        enableProdMode();
        this.logRouteDebug('ngOnInit:start', this.snapshot());
        await this.service.init(this);
        this.logRouteDebug('ngOnInit:after-service-init', this.snapshot());
    }

    private installRouteDebugHooks() {
        this.logRouteDebug('app-constructor', this.snapshot());
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationStart) {
                this.logRouteDebug('NavigationStart', { url: event.url, snapshot: this.snapshot() });
            } else if (event instanceof RoutesRecognized) {
                this.logRouteDebug('RoutesRecognized', { url: event.url, urlAfterRedirects: event.urlAfterRedirects });
            } else if (event instanceof NavigationEnd) {
                this.logRouteDebug('NavigationEnd', { url: event.url, urlAfterRedirects: event.urlAfterRedirects, wizRoute: window['WizRoute'] });
            } else if (event instanceof NavigationCancel) {
                this.logRouteDebug('NavigationCancel', { url: event.url, reason: event.reason });
            } else if (event instanceof NavigationError) {
                this.logRouteDebug('NavigationError', {
                    url: event.url,
                    errorName: event.error?.name,
                    errorMessage: event.error?.message,
                    error: event.error,
                    snapshot: this.snapshot()
                });
            }
        });
        window.addEventListener('error', (event: ErrorEvent) => {
            this.logRouteDebug('window:error', {
                message: event.message,
                filename: event.filename,
                lineno: event.lineno,
                colno: event.colno,
                error: event.error
            });
        });
        window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
            this.logRouteDebug('window:unhandledrejection', { reason: event.reason });
        });
    }

    private snapshot() {
        return {
            debugVersion: POS_ROUTE_DEBUG_VERSION,
            href: window.location.href,
            pathname: window.location.pathname,
            routerUrl: this.router?.url,
            routeCount: this.router?.config?.length,
            routes: this.describeRoutes(this.router?.config || [])
        };
    }

    private describeRoutes(routes: any[]) {
        return routes.map((route: any, index: number) => ({
            index,
            path: route.path || '',
            hasMatcher: !!route.matcher,
            redirectTo: route.redirectTo || '',
            component: route.component?.name || '',
            childCount: route.children?.length || 0,
            children: (route.children || []).slice(0, 12).map((child: any, childIndex: number) => ({
                index: childIndex,
                path: child.path || '',
                hasMatcher: !!child.matcher,
                redirectTo: child.redirectTo || '',
                component: child.component?.name || ''
            }))
        }));
    }

    private logRouteDebug(label: string, payload: any) {
        console.log(`[POS-ROUTE-DEBUG][${POS_ROUTE_DEBUG_VERSION}] ${label}`, payload);
    }
}
